import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { AdobeLaunchService } from 'src/app/services/adobe-launch.service'

import { environment } from '../../../../environments/environment'
import { FiltersService } from '../../../services/filtersService.service'

@Component({
  selector: 'VFA-compare-tool-banner',
  templateUrl: './compare-tool-banner.component.html',
  styleUrls: ['./compare-tool-banner.component.scss'],
})
export class CompareToolBannerComponent implements OnInit {
  @Output() clearSelectedCheckbox = new EventEmitter()
  compareCount: number
  compareFundList: any = []
  innerwidth: any
  finalURL: string = environment.compareURLPrefix

  constructor(
    public filterService: FiltersService,
    // public adobeAnalyticsService: AdobeAnalyticsService,
    public adobeLaunchService: AdobeLaunchService,
  ) {}

  ngOnInit() {
    this.innerwidth = window.innerWidth

    this.filterService.compareFunds.subscribe((res) => {
      this.compareFundList = res
    })
  }

  detectScreenSize() {
    this.innerwidth = window.innerWidth
  }

  compareFunds(event: Event) {
    event.preventDefault()

    const fundIdString = this.getSelectedFundsString()

    this.finalURL = this.finalURL.concat(fundIdString)

    //Replace with router once we have our page built out
    window.open(this.finalURL, '_self')
    
    // Reset finalURL to it's initial value
    this.finalURL = environment.compareURLPrefix

    /*    this.adobeAnalyticsService.trackProcess(
      'Compare',
      'Dynamic Funds List Page - Filter Output Section',
      'Button',
    ) */
    this.adobeLaunchService.callToAction(
      'Compare',
      'Dynamic Funds List Page - Filter Output Section',
      'Button',
    )
  }

  getSelectedFundsString() {
    const selectedFundsStr = []
    for (const f of this.compareFundList) {
      selectedFundsStr.push(f)
    }
    return selectedFundsStr.join(',')
  }

  clearSelected() {
    this.filterService.compareFundCount = 0
    this.clearSelectedCheckbox.emit()
    this.filterService.compareFunds.next([])
  }
}
